var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImageFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5817_48060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F9FAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1112 16.8889V22.6666C11.1112 22.8555 11.0472 23.0138 10.9194 23.1415C10.7915 23.2694 10.6332 23.3333 10.4443 23.3333C10.2552 23.3333 10.0969 23.2694 9.96939 23.1415C9.84168 23.0138 9.77783 22.8555 9.77783 22.6666V9.69241C9.77783 9.46471 9.85487 9.27389 10.0089 9.11997C10.1629 8.96589 10.3537 8.88885 10.5814 8.88885H16.3094C16.4992 8.88885 16.6686 8.94841 16.8176 9.06752C16.9665 9.18663 17.0604 9.3413 17.0992 9.53152L17.3298 10.6666H21.4187C21.6464 10.6666 21.8372 10.7433 21.9912 10.8966C22.1452 11.05 22.2223 11.24 22.2223 11.4666V17.8669C22.2223 18.0935 22.1452 18.2834 21.9912 18.4366C21.8372 18.59 21.6464 18.6666 21.4187 18.6666H17.4685C17.2787 18.6666 17.1093 18.6071 16.9603 18.488C16.8114 18.3689 16.7175 18.2142 16.6787 18.024L16.4481 16.8889H11.1112ZM17.9112 17.3333H20.8889V12H16.8872C16.6975 12 16.5282 11.9404 16.3792 11.8213C16.2301 11.7022 16.1362 11.5475 16.0974 11.3573L15.8667 10.2222H11.1112V15.5555H16.8907C17.0804 15.5555 17.2497 15.6151 17.3987 15.7342C17.5478 15.8533 17.6417 16.008 17.6805 16.1982L17.9112 17.3333Z",
    fill: "#7C7D79"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5817_48060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageFlag);
export default __webpack_public_path__ + "static/media/noImageFlag.8ba5839f9f8cb88f86575787f3c82d69.svg";
export { ForwardRef as ReactComponent };